//Calc Script
window.scriptLoaded = true;

//Calcs an interpolation factor for WLTP to real world range.
// For a given value will give say zero = urban,  100= full highway
function calculateFactor(value) {
	// y2 is a rule of thumb from WLTP to straight open road driving
	const x1 = 0, y1 = 1.03;
	const x2 = 100, y2 = 0.78;
	const factor = y1 + ((value - x1) * (y2 - y1)) / (x2 - x1);
	return factor;
}

// Linear interpolation function
function linearInterpolation(point1, point2, x) {
  const slope = (point2.y - point1.y) / (point2.x - point1.x);
  const y = point1.y + slope * (x - point1.x);
  return y;
}

// Function to find the two closest points for interpolation
function findBoundingPoints(dataPoints, x) {
  let point1, point2;
  for (let i = 0; i < dataPoints.length - 1; i++) {
	if (x >= dataPoints[i].x && x <= dataPoints[i + 1].x) {
	  point1 = dataPoints[i];
	  point2 = dataPoints[i + 1];
	  break;
	}
  }
  return { point1, point2 };
}

// Function to interpolate y values for each integer x value
function interpolateDataForIntegers(dataPoints) {
  const interpolatedValues = [];
  const minX = Math.ceil(dataPoints[0].x);  // Start from the smallest integer x
  const maxX = Math.floor(dataPoints[dataPoints.length - 1].x);  // End at the largest integer x

  for (let x = minX; x <= maxX; x++) {  // Iterate through integer x values
	const { point1, point2 } = findBoundingPoints(dataPoints, x);
	if (point1 && point2) {
	  const y = linearInterpolation(point1, point2, x);
	  interpolatedValues.push({ x, y });
	} else {
	  // If x is outside the range of data points, push null or some indication as needed
	  interpolatedValues.push({ x, y: null });
	}
  }

  return interpolatedValues;
}

function flashUpdate(element) {
  if (!element) return;
  element.classList.remove('fade-update'); // restart animation if already running
  void element.offsetWidth; // trigger reflow
  element.classList.add('fade-update');
}

function positionBubble(slider, bubble) {
    if (!slider || !bubble) return;
	
    // 0–1 fraction of slider travel
    const value = Number(slider.value);
    const min   = Number(slider.min);
    const max   = Number(slider.max);
    const pct   = (value - min) / (max - min);

    /* Track width minus thumb gives true travel distance.
       Default thumb ≈16 px; adjust if your custom thumb is wider. */
    const thumbW = 25;                           // px
    const trackW = slider.offsetWidth - thumbW;  // usable travel

    // Pixel position of the thumb centre
    const thumbCenter = pct * trackW + thumbW / 2;

    // Centre the bubble above the thumb
    const bubbleHalf = bubble.offsetWidth / 2;
    bubble.style.left = `${thumbCenter}px`;
	//console.log ("positionBubble", bubble.style.left);
	const pxOffset = -pct * thumbW + thumbW / 2 - bubbleHalf;
	bubble.style.left = `calc(${pct * 100}% + (${pxOffset}px))`;	
	bubble.style.transform = "";
  }


var realrange = document.querySelectorAll('.range-slider');
// x is celsius temp, y is percent of wltp
const dataPoints = [
{x: -19.897435897435898, y: 48.588235294117645},
{x: -16.102564102564102, y: 52.705882352941174},
{x: -12.615384615384617, y: 56.41176470588235},
{x: -9.743589743589745, y: 60.94117647058823},
{x: -6.153846153846155, y: 66.70588235294117},
{x: -3.384615384615387, y: 71.6470588235294},
{x: 0.3076923076923066, y: 78.6470588235294},
{x: 3.897435897435898, y: 86.05882352941175},
{x: 6.9743589743589745, y: 90.58823529411764},
{x: 10.051282051282051, y: 94.29411764705883},
{x: 13.641025641025642, y: 98},
{x: 17.846153846153847, y: 99.23529411764706},
{x: 21.846153846153847, y: 100.47058823529412},
{x: 25.33333333333333, y: 98.41176470588235},
{x: 28.615384615384613, y: 93.47058823529412},
{x: 32.1025641025641, y: 86.47058823529412},
{x: 34.97435897435897, y: 78.6470588235294},
{x: 37.64102564102564, y: 73.70588235294117},
{x: 39.8974358974359, y: 70}
];

if (realrange.length > 0)  {
	// Temp source - taken from https://www.geotab.com/blog/ev-range/ and adjusted for wltp

	// Align the temperature bubble when the page first loads
	(() => {
	// Cache your elements just once
	const slider = document.getElementById('rangeTemp');
	const bubble = document.getElementById('tempBubble');
	
	// One function to do the work
	const updateBubble = () => positionBubble(slider, bubble);
	
	// Initial positioning
	updateBubble();
	
	// Re‑align after full page load and on resize
	['load', 'resize'].forEach(evt =>
		window.addEventListener(evt, updateBubble)
	);

	})();
	
	document.addEventListener('input', function(e) {
		// Check if the event is triggered by a slider
		if (e.target.classList.contains('range-slider')) {
			// Find the closest parent that represents the car section
			let carSection = e.target.closest('.real-range-section');

			// Find the real-range element within the same car section
			let realRange = carSection.querySelector('.real-range');
			
			let tempDisplay = carSection.querySelector('.sliderValue');	   
			let wltp = realRange.dataset.wltp;
			let temp = carSection.querySelector('#rangeTemp');
			let mix = carSection.querySelector('#rangeStyle');
			const estConsSpan = carSection.querySelector('.real-consumption');   // one span serves both units
			const swapBtn     = carSection.querySelector('.swap-unit');          // ghost‑icon toggle (may be null)
			
			let soh = 1;
			let sohElement = carSection.querySelector('.soh');
			if (sohElement && !isNaN(parseFloat(sohElement.dataset.soh))) {
				soh = parseFloat(sohElement.dataset.soh);
			}	
			
			const usableOriginal = parseFloat(estConsSpan.dataset.usable);
			const usable         = isNaN(usableOriginal) ? 0 : usableOriginal * soh;   // guard against NaN
			if (!usable) return;    // nothing to calculate – prevents NaN

			// Calc real range
			// 1.03 -> 0.77
			//console.log (calculateFactor(mix.value));
			
			// Take our existing datapoints, and interpolate all integers in between
			const tempFactor = interpolateDataForIntegers(dataPoints);
			//console.log (tempFactor);
			const tempPoints = {};  // Put into an associative array
			tempFactor.forEach(point => {
			  tempPoints[point.x] = point.y;
			});
			console.log (soh,calculateFactor(mix.value),tempPoints[temp.value]);
			
			// Calc real range using 1.03 -> 0.78 (urban to open road)
			let newRange = calculateFactor(mix.value) * wltp; // Apply WLTP adjustments
			newRange = newRange * (tempPoints[temp.value] / 100); // Apply temperature adjusters
			
			// Apply SoH
			newRange = newRange * soh;
			
			//console.log (usable);
			// Calc consumption figures
			//estConsKM.textContent = Math.round((newRange / parseFloat(usable)) * 10) / 10 + " km / kWh";
			//estConsWH.textContent = Math.round(((parseFloat(usable) * 100) / newRange) * 10) / 10 + " kWh / 100 km";

			const consKm = Math.round((newRange / parseFloat(usable)) * 10) / 10;
			const consWh = Math.round(((parseFloat(usable) * 100) / newRange) * 10) / 10;
			
			const consKmStr = `${consKm} km / kWh`;
			const consWhStr = `${consWh} kWh / 100 km`;
			
			// cache the strings (including units) so the swap‑icon handler can use them
			estConsSpan.dataset.km = consKmStr;
			estConsSpan.dataset.wh = consWhStr;
			
			// show whichever unit is currently active
			const currentUnit = swapBtn ? swapBtn.getAttribute('data-state') : 'km';
			estConsSpan.textContent = currentUnit === 'km' ? consKmStr : consWhStr;

			// Update the real-range element
			tempDisplay.textContent = temp.value + '°'
			realRange.textContent = Math.floor(newRange) + ' km'; // or any unit you are using
			flashUpdate(realRange);
			// ── Move the temperature bubble ──
			if (e.target.id === 'rangeTemp') {
				const bubble = carSection.querySelector('#tempBubble');
				positionBubble(e.target, bubble);
				}
		}
		
		// State of Health slider
		if (e.target.classList.contains('soh-slider') || e.target.classList.contains('soh-input')) {
			const section = e.target.closest('.real-range-section');
			const slider = section.querySelector('.soh-slider');
			const input = section.querySelector('.soh-input');
			const sohElement = section.querySelector('.soh');
		
			// Keep them in sync
			if (e.target === slider) {
			  input.value = slider.value;
			} else {
			  slider.value = input.value;
			}
		
			// Update data-soh attribute
			let percent = parseFloat(input.value);
			percent = Math.min(100, Math.max(50, percent)); // Clamp between 50 and 100
			sohElement.dataset.soh = (percent / 100).toFixed(2);
		
			// Trigger recalculation
			const styleSlider = section.querySelector('#rangeStyle');
			styleSlider.dispatchEvent(new Event('input', { bubbles: true }));
		  }
	});

}

//Calc Script

var calc = document.getElementById('calcCost');
if (calc) {
	window.costCalcICE = '';
	calc.addEventListener('click', function(e) {
		e.preventDefault();
		if (!calcRunningCosts()) {
			return;
		};
		const calcMove  = new MoveTo();
		const target = document.getElementById('calcCost');
		const result = document.getElementById('resultanchor');
		result.style.display = 'block';
		calcMove.move(result);
	});	
	
	document.getElementById('fuel').addEventListener('input', function(event) {
		window.costCalcICE ='';
		document.getElementById('selectedICE').textContent='';
	});
	
	// If the average checkbox ticked, clear out the make/mode
	document.getElementById('averageev').addEventListener('change', function () {
		// Get the checkbox state
		const isChecked = this.checked;
	
		// Select the dropdowns
		const selectBox1 = document.getElementById('make');
		const selectBox2 = document.getElementById('model');
	
		// If the checkbox is checked, set the dropdowns to 0
		if (isChecked) {
			selectBox1.selectedIndex = 0;
			selectBox2.selectedIndex = 0
			while (selectBox2.options.length > 0) {
				selectBox2.remove(0);
			};
		}
	});

	

	/****** Slider stuff ********/
	const kmtrigger = document.getElementById("kms");
	const kmunittrigger = document.getElementById("kmsunit");
	kmtrigger.addEventListener("input", updateSlider);
	kmunittrigger.addEventListener("change", updateSlider);
	function updateSlider() {
		let totalKm = getTotalForYear();	
		let slider = document.getElementById("myRange");
		slider.max = totalKm;
		//slider.step = 100;
		//slider.value = 0;
		var output = document.getElementById("sliderValue");
		output.textContent = slider.value  + " km / year";
	}
	
	const slider = document.getElementById("myRange");
	
	slider.oninput = function() {
		var output = document.getElementById("sliderValue");
	  output.textContent = this.value + " km / year";
	}
}

// Converts different km / day etc into a Annial
function getTotalForYear() {
	var kms = parseFloat(document.getElementById('kms').value);
	var kmsunit = document.getElementById("kmsunit");
	var multiplierMap = { "d": 365, "w": 52, "m": 12, "y": 1 };
	if (kms==0) {kms = 1;}
	var totalForYear = kms * (multiplierMap[kmsunit.value] || 1);
	return totalForYear;
}
		
// Called when modal for plate retreival appears on screen.		
function plateCallback() {
	const submitButton = document.getElementById('plate-modal_submitPlate');
	const plateInput = document.getElementById('plate-modal_plate');
	const plateApply = document.getElementById('plate-modal_usePlate');
	plateInput.focus();
	window.fuelEconomy= 7;
	console.log ("PlateCallback",submitButton);
	
	plateApply.addEventListener('click', function(e) {
		e.preventDefault();
		var fuelValue = document.getElementById('fuel');
		fuelValue.value =window.fuelEconomy;
		console.log ("clicked plate apply", window.fuelEconomy);
		window.onlymodal.close();
	});

	plateInput.addEventListener('keydown', function(e) {
		if (e.key === "Enter" || e.keyCode === 13) {
			e.preventDefault(); 
			handleFormSubmission();
		}
	});
	submitButton.addEventListener('click', function(e) {
		e.preventDefault(); 
		handleFormSubmission();
	});
	
	function handleFormSubmission() {
		console.log ("Plate submit");

		const plateResult = document.getElementById('plate-modal_plateResult');
		const plate = plateInput.value;
		var result = "";
		// Show spinner
		const loadingIcon = document.getElementById('plate-modal_spinner');
		loadingIcon.style.display = 'block';
		window.costCalcICE='';
		document.getElementById('selectedICE').textContent='';
			
		fetch(`/wp-json/api_proxy/v1/fetch/?plate=${plate}`)
			.then(response => response.json())
			.then(data => {
				// Handle the API response here.
				if (data.ErrorCode==30 || data.ErrorCode==40) {
					result = "Couldn't find a vehicle with that plate";
				} else {
					const fuelEconomyText = data.FuelEconomyText;
					const regexPattern = /(\d{1,2}(?:\.\d)?)L/;
					const match = fuelEconomyText.match(regexPattern);
					
					if (match) {
						result = data.mvrYear + " " + data.Make + " " + data.Model + " " + data.FuelEconomyText;
						window.costCalcICE = data.mvrYear + " " + data.Make + " " + data.Model + " " + data.SubModel;
						document.getElementById('selectedICE').textContent = window.costCalcICE;
						window.fuelEconomy =  ( match[1]); // Display the extracted fuel economy
						document.getElementById('plate-modal_usePlate').style.visibility = "visible";
					} else {
						result =  'No valid fuel economy data found.'	;

					}
				}
				console.log(data);
				const plateApply = document.getElementById('plate-modal_usePlate');
				plateResult.textContent = result;
				loadingIcon.style.display = 'none';
			})
			.catch(error => {
				console.error('Error fetching data:', error);
			});
	};
};


// Called from 
function calcRunningCosts() {
	if (!window.scriptLoaded) {
		alert('Script is still loading, please wait...');
		return;
	}
	const RUC = 76; // per 100 km
	const ICECosts = (0.101/1.61) *0.8;
	const EVCosts = (0.061/1.61) * 0.8; // Adjusted for improved battery re-gen leading to much less brake costs.
	// Source: https://www.osti.gov/biblio/1780970 - although US currency and costs, NZ costs seem the similar on dollar for dollar parity (no exch rate, actually cheaoper)
	// https://publications.anl.gov/anlpubs/2021/05/167399.pdf p. 83

	
	//Validator
	var fields = [
		{id: 'kms', min: 1, max: 1000000},
		{id: 'fuel', min: 0.1, max: 20},
		{id: 'fuelprice', min: 0.01, max: 10},
		{id: 'price', min: 0.1, max: 300},
		{id: 'dcprice', min: 0.1, max: 300}
	];
	var hasError = false;
	var firstEl = null;
	
	// Iterate over each field
	for (var i = 0; i < fields.length; i++) {
		var fieldElement = document.getElementById(fields[i].id);
		var errorMessage = fieldElement.nextElementSibling;
	
		// Check if the field value is within the min and max
		var value = Number(fieldElement.value);
		if(value < fields[i].min || value > fields[i].max) {
			errorMessage.textContent = `* Valid number required`;
			errorMessage.style.display = 'block';
			if (!firstEl) {
				firstEl = fieldElement;
			}
			hasError=true;
		} else {
			errorMessage.style.display = 'none';
		}
	}
	if (hasError) {
		const calcError  = new MoveTo();
		calcError.move(firstEl);
		return false;
	}
	
	var selectElements = document.querySelectorAll('select.validate');
	var averageev = document.getElementById("averageev");
	
	if (!averageev.checked) {
		for (var i = 0; i < selectElements.length; i++) {
			var select = selectElements[i];
			var errorMessage = select.nextElementSibling;
			if (select.selectedIndex === 0 || select.value === "") {
				errorMessage.textContent = `* Choose a vehicle`;
				errorMessage.style.display = 'block';
				const calcError  = new MoveTo();
				calcError.move(select);
				return false;   
			} else {
				// Hide the error message
				errorMessage.style.display = 'none';
			}
		}
	}
	
	var selectElement = document.getElementById('model');
	var selectedOption = selectElement.selectedOptions.length > 0 ? selectElement.selectedOptions[0] : null;
	var evmodel = "EV";
	
	if (selectedOption && selectedOption.hasAttribute('data-wh')) {
		var dataWh = parseFloat(selectedOption.getAttribute('data-wh'));
		var dataR = parseFloat(selectedOption.getAttribute('data-r'));
		evmodel = selectedOption.innerText;
		
	} else {
		// Default values when no option is selected 
		/* MY	157
		M3	149
		atto	156
		zs	177
		Leaf	171   Average = 162*/
		var dataWh = 162;
		var dataR = 350;
	}

	var kms = parseFloat(document.getElementById('kms').value);
	var fuel = parseFloat(document.getElementById('fuel').value);
	var fuelprice = parseFloat(document.getElementById('fuelprice').value);
	var price = parseFloat(document.getElementById('price').value);
	var dcprice = parseFloat(document.getElementById('dcprice').value);
	var slider = document.getElementById("myRange");
	
	var totalForYear = getTotalForYear();
	var fuelCost = (totalForYear/100) * (fuel * fuelprice);
	var elecCost = (dataWh / 1000) * (price/100) * (totalForYear-slider.value);
	var totalFuelCost = fuelCost;
	var totalElecCost = elecCost;
	var ruccurrent = document.getElementById("ruccurrent");

	//var rucev = document.getElementById("rucev");
	var rucev = true;
	var publicCost =  0;
	if (slider.value > 0) {
		publicCost = (dataWh / 1000) * (dcprice/100) * (slider.value);
		totalElecCost += publicCost;
	}
	console.log("dataWh=", dataWh," kms=",kms," fuel=",fuel," fuelprice=",fuelprice," price=",price," totalYear=",totalForYear," fuelcost=",fuelCost, " elecCost=",elecCost, " publicCharge=",slider.value," publicCost=",publicCost);

	// Build results
	function tableRowTemplate(cell1, cell2,cell3) {
		return `
			<tr>
				<td class="calc-1">${cell1}</td>
				<td class="calc-2">${cell2}</td>
				<td class="calc-3">${cell3}</td>
			</tr>
		`;
	}
	
	function getCurrency(amount) {
		//amount = Math.ceil(amount);
		return amount.toLocaleString('en-NZ', {
		  style: 'currency',  currency: 'NZD',	minimumFractionDigits: 0, maximumFractionDigits: 0
		});
	}
	
	// Clear it
	// Textual output
	if (window.costCalcICE == '') {
		iceCarModel = 'combustion car';
		iceCarModelHeader = 'Current Car';
	} else {
		iceCarModel = '<strong>' + window.costCalcICE + '</strong>';
		iceCarModelHeader = iceCarModel.replace(/\d{4}\s/, "");
	}
	var tbody = document.querySelector("#resulttable tbody");
	tbody.innerHTML='';
	tbody.innerHTML += tableRowTemplate("",`<span style='font-size:0.85em;word-break: break-word;'>${iceCarModelHeader}</span>`,"<span style='font-size:0.85em;word-break: break-word;'>"+evmodel)+"</span>";
	tbody.innerHTML += tableRowTemplate("Fuel", getCurrency(fuelCost),"")
	tbody.innerHTML += tableRowTemplate("Electricity (home)", "",getCurrency(elecCost))
	if (slider.value > 0) {
		tbody.innerHTML += tableRowTemplate("Electricity (public charger)", "",getCurrency(publicCost))
	}
	tbody.innerHTML += tableRowTemplate("Maintenance & Service", getCurrency(totalForYear*ICECosts),getCurrency(totalForYear*EVCosts))
	totalFuelCost += totalForYear*ICECosts;
	totalElecCost += totalForYear*EVCosts;
	
	//RUC
	if (rucev === true || ruccurrent.checked) {
		rucevtext = "";ruccurrenttext = "";
		if (ruccurrent.checked) {
			ruccurrenttext = getCurrency((totalForYear / 1000) * RUC);
			totalFuelCost += ((totalForYear / 1000) * RUC);
		}
		if (rucev === true) {
			rucevtext = getCurrency((totalForYear / 1000) * RUC);
			totalElecCost += ((totalForYear / 1000) * RUC);
		}

		tbody.innerHTML += tableRowTemplate("Road User Charges (RUC)", ruccurrenttext, rucevtext)
	}
	
	let centsICE = totalFuelCost / totalForYear;
	let centsEV = totalElecCost / totalForYear;
	let fuelpriceFormatted = '$' + fuelprice.toFixed(2) + ' per litre';
	
	var totalWrap="<span style='color:var(--green);'>"
	var colorElec = totalElecCost < totalFuelCost ? 'green' : 'red';
	var colorFuel = totalFuelCost < totalElecCost ? 'green' : 'red';
	var totalElecLine = `<span style='font-weight:bold;color:var(--${colorElec});'>${getCurrency(totalElecCost)}</span>`;
	var totalFuelLine = `<span style='font-weight:bold;color:var(--${colorFuel});'>${getCurrency(totalFuelCost)}</span>`;
	tbody.innerHTML += tableRowTemplate("<span style='font-weight:bold;'>Annual Running Cost</span>", totalFuelLine, totalElecLine);
	var centsIceLine = '<span style="font-weight:normal;">' +  Math.round(centsICE * 100) + "c/km" + "</span>";
	var centsElecLine = '<span style="font-weight:normal;">' +  Math.round(centsEV * 100) + "c/km" + "</span>";
	tbody.innerHTML += tableRowTemplate("<span>Cost per km</span>",centsIceLine,centsElecLine);
	
	var text = '';
	var charts= '';
	if (totalElecCost < totalFuelCost) {
		text = `<p style="font-size:0.9em;">The <strong>${evmodel}</strong> charged at ${price} cents/kWh, is cheaper to run than a ${iceCarModel} using ${fuel}L / 100 km (${fuelpriceFormatted}).</p>`;
		document.getElementById("calcresults").innerText += text;
		// Calculate the proportion for the electricity bar
		const proportion = totalElecCost / totalFuelCost;
		totalElecCost = totalElecCost * 4;
		totalFuelCost = totalFuelCost * 4;
		iceCarModel = iceCarModel.charAt(0).toUpperCase() + iceCarModel.slice(1);
		
		charts = `<div style="margin-top:2rem; padding: 6px 10px;">
		  <div style="font-weight:bold;margin-bottom:10px;font-size:1.1em;">Basic running costs over 4 years</div>
			<div class="item">
			  <div class="label">${evmodel}</div>
			  <div class="bar-wrapper">
				<div class="bar electricity-bar" style="--amount: ${proportion};"></div>
				<div class="cost" style="width: calc( ${proportion} * 100%">${getCurrency(totalElecCost)}</div>
			  </div>
			</div>
		
			<div class="item">
			  <div class="label">${iceCarModel}</div>
			  <div class="bar-wrapper">
				<div class="bar-container">
				</div>
				<div class="cost">${getCurrency(totalFuelCost)}</div>
			  </div>
			</div>
			<div style="font-size: 11px;font-family: inter;line-height: 1.2;padding-top: 20px;">Running cost includes maintenance, RUCs, and refueling/recharging. It is not the total cost of ownership (which includes depreciation, finance, and insurance).</div>
		  </div>`;
		  
	}
	document.getElementById("resultchart").innerHTML = charts;
	
	var summary = `<h3 style="margin-bottom:10px;margin-top:10px;">Annual Running Cost Comparison</h3>
	<span style="font-size:0.9em;">Based on ${totalForYear.toLocaleString('en-NZ')} km of travel per year.</span> ${text}`;
	document.getElementById("calcresults").innerHTML=summary;

	return true;
}